<template>
<div>
  <baseaktarim
    :logo="null"
    title="Arkman Restaurant Aktarımı"
    v-model="items"
    v-on:submitfile="SubmitFile"
    :status="status"
    :menuitems="menuItems"
    successTitle="Aktarılan Restaurant Verileri"
    errorTitle="Hatalı Restaurant Verileri"
    confirmTitle="Restaurant Aktarımı"
    v-on:menuclick="menuClick"
  ></baseaktarim>
</div>
</template>

<script>
import baseaktarim from "../coperbaseaktarim";
import tool from "../../tools";
 
export default {
  data() {
    return {
      items: [],
      status: tool.NewSatatus(),
      menuItems: [
        {
          title: this.$t('Download-Sample-File'),
        },
      ],
    };
  },
   
  components: {
    baseaktarim,
  },
  methods: {
    menuClick(index) {
      if (index == 0) {
        this.DownloadFile("CoperRestaurantRezAktarim.xlsx");
      } else if (index == 1) {
      }
    },

    DownloadFile(file) {
      var prm = {
        FileName: file,
      };

      this.status.loading = true;
      setTimeout(() => {
        tool.api_post_FileDownload(this, "CariStream/DownloadFile", prm).then(
          (response) => {
            tool.CreateDownloadLink(response, file);
            this.status.loading = false;
          },
          (response) => {
            this.status = tool.responseToStatus(response);
          }
        );
      }, 5000);
    },


    SubmitFile(files) {
      let formData = new FormData();
      for (var i = 0; i < files.length; i++) {
        let file = files[i];
        formData.append('files[' + i + ']', file);
      }

      this.status.loading = true;
      tool.api_file_post(this, "CoperStream/ArkmanRestaurantRezStream", formData).then(
        response => {
          this.items = response.body;
          this.status.loading = false;
        },
        response => {
          this.status = tool.responseToStatus(response);
        }
      );

    }
  }

};
</script>
